import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {Settings} from '/constant/TestIDs';
import testProperties from '/util/testing/testProperties';

import {styles} from './AccountSettingSection.style';

interface AccountSettingSectionProps {
  testID: string | null;
  title: string;
  defaultValue: string;
  description: string;
}

const AccountSettingSection: React.FC<AccountSettingSectionProps> = ({
  testID = null,
  title = '',
  defaultValue = '',
  description = '',
}: AccountSettingSectionProps) => (
  <View {...testProperties(testID)} style={styles.section}>
    <Gutter>
      <ListItem
        readonly
        label={
          <View>
            <Text
              testID={Settings.accountSettingsItemTitle}
              style={styles.listItemTitle}
              variant="button"
              accessible={true}
              accessibilityRole="header">
              {title}
            </Text>

            <View style={styles.fakeInput}>
              <Text
                testID={Settings.accountSettingsItemValue}
                emphasis="medium"
                variant="body"
                accessible={true}
                accessibilityLabel={`${defaultValue}, default value`}>
                {defaultValue}
              </Text>
            </View>

            <Text
              testID={Settings.accountSettingsItemDescription}
              variant="caption"
              emphasis="low"
              accessible={!!description}>
              {description}
            </Text>
          </View>
        }
      />
    </Gutter>
  </View>
);

export default AccountSettingSection;
